<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/MpBgxk/tc-custom/9781649792204.jpg?1705540958120" alt="This image is the cover for the book Panic Through the Pines"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Panic Through the Pines
      </h1>
      <p class="bookDescription body article font2">
        <p style='margin-top:0mm;margin-right:0mm;margin-bottom:8.0pt;margin-left:0mm;font-size:16px;font-family:"Times New Roman",serif;'>“Watching the fog rise off the lake simultaneously with steam rising from the coffee was my once beloved morning ritual. I look out onto the lake and ask myself a simple question: What do I do next?  It was a gradual transition, from being motivated to remain sociable and pleasant throughout the course of the days and weeks then the once joyous cheers by the nightly fire turned slowly into a new level of solitude and anger.” </p><p style='margin-top:0mm;margin-right:0mm;margin-bottom:8.0pt;margin-left:0mm;font-size:16px;font-family:"Times New Roman",serif;'><br/>James Marshall rides an exciting rollercoaster through life, and his journey comes with many a twist and turns and dark tunnels. The view of the mountains and tall pines nestled in the heart of the Adirondacks become a permanent second home to create countless memories and family joy. </p><p><br/></p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Stephen Conroy
      </h2>
      
      <p class="authorDescription body article"><p style='margin:0cm;margin-bottom:.0001pt;font-size:15px;font-family:"Arial",sans-serif;text-align:justify;'><span style='font-family:"Times New Roman",serif;'>Stephen Conroy has lived his entire life in the Capital Region in Upstate New York and is proud to produce his first published book, while incorporating some local ties within the story. He is married and has two young daughters with his wife, Nicole. The story started forming listening to his dad tell campfire stories on their summer vacations to help lead the development of this story.</span></p></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Austin Macauley Publishers
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?79396b86